import React from 'react';
import images from '../../Theming/images';

const icons = {
  purple: images.purple_kindred_icon,
  black: images.black_kindred_icon,
  white: images.white_kindred_icon,
  new: images.new_kindred_icon,
  discounts_and_savings: images.discounts_and_savings_icon,
};

type IconProps = {
  color: keyof typeof icons;
  style?: React.CSSProperties;
};
const KindredIcon: React.FC<IconProps> = ({ color, style }) => {
  return <img src={icons[color]?.default} style={style} alt="kindred icon" />;
};

KindredIcon.defaultProps = {
  style: {
    minWidth: '3rem',
    width: '7%',
  },
};

export default KindredIcon;
